module.exports = __webpack_public_path__ + "static/media/dinesh.2fd796f0.jpg";